import React, { Fragment } from 'react';
import { Header, Form, Label } from 'semantic-ui-react';
import yup from 'yup';
import Field from '../Field';
import withVericationForm from './withVericationForm';

const ERROR_REQUIRED = 'This field is required';

class Article8Form extends React.PureComponent {
  _onChange = (e, { name, value }) =>
    this.props.onChange(this.props.documentId, name, value);

  render = () => {
    const { onBlur, values, errors, touched } = this.props;
    return (
      <Fragment>
        <Header>Article 8</Header>
        <Form>
          <Field
            error={errors.amountInEuros}
            touched={touched.amountInEuros}
          >
            <Form.Input
              labelPosition="left"
              label="Amount"
              placeholder="00.00"
              name="amountInEuros"
              type="number"
              value={values.amountInEuros}
              onChange={this._onChange}
              onBlur={onBlur.bind(this, 'amountInEuros')}
            >
              <Label basic>€</Label>
              <input />
            </Form.Input>
          </Field>
          <Field
            error={errors.dateOfBilling}
            touched={touched.dateOfBilling}
          >
            <Form.Input
              label="Date of billing"
              name="dateOfBilling"
              value={values.dateOfBilling}
              onChange={this._onChange}
              placeholder="DD/MM/YYYY"
              onBlur={onBlur.bind(this, 'dateOfBilling')}
            />
          </Field>
        </Form>
      </Fragment>
    );
  };
}

const formikConfig = {
  mapPropsToValues: props => {
    return { ...props.formValues };
  },
  validationSchema: () => {
    return yup.object().shape({
      amountInEuros: yup.string().required(ERROR_REQUIRED),
      dateOfBilling: yup.string().required(ERROR_REQUIRED)
    });
  }
};

export default withVericationForm(formikConfig, [
  'amountInEuros',
  'dateOfBilling'
])(Article8Form);



// WEBPACK FOOTER //
// ./src/component/verification_forms/Article8Form.js